import {ChangeDetectionStrategy, Component, ViewChild } from '@angular/core';
import { CalltoactionService } from './calltoaction.service';

@Component({ standalone: false,
    selector: 'calltoaction-container',
    template: `
      <div class="calltoaction-container">
        @if (calltoaction) {
          <calltoaction
            #cta
            [template]="calltoaction.template"
            [position]="calltoaction.position"
            [closeOnOutsideClick]="calltoaction.closeOnOutsideClick"
            [maxWidth]="calltoaction.maxWidth"
            [ref]="calltoaction.ref"
            [event]="calltoaction.event"
            [useTruncationParent]="calltoaction.useTruncationParent"
            [verticalOffset]="calltoaction.verticalOffset"
            [horizontalOffset]="calltoaction.horizontalOffset"
            [keepWithinBoundary]="calltoaction.keepWithinBoundary"
            [usesHover]="calltoaction.usesHover">
          </calltoaction>
        }
      </div>
      `,
      changeDetection: ChangeDetectionStrategy.Eager
  })
  export class CalltoactionContainerComponent {  
    @ViewChild("cta") cta: any;
    calltoaction: any = null;

    constructor(private ctas: CalltoactionService) {
      this.ctas.getComponents().subscribe((cta) => {
        this.calltoaction = cta;
      });

      this.ctas.getChanges().subscribe((d: any) => {
        if(d === "redraw" && this.cta) {
          this.cta.redraw();
        }
      });
    }  
  }
